import { Link } from "react-router-dom";
import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { PHONE_TEL, waLink } from "@/data/site";

export function MobileBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-line bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden" data-testid="mobile-sticky-bar">
      <a href={`tel:${PHONE_TEL}`} className="flex flex-col items-center gap-1 py-2.5 text-[12px] font-semibold text-ink" data-testid="mobile-bar-call"><Phone className="h-5 w-5 text-saffron" aria-hidden />Call</a>
      <a href={waLink()} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-1 py-2.5 text-[12px] font-semibold text-ink" data-testid="mobile-bar-whatsapp"><MessageCircle className="h-5 w-5 text-[#128C4A]" aria-hidden />WhatsApp</a>
      <Link to="/booking" className="m-1.5 flex flex-col items-center justify-center gap-1 rounded-xl bg-saffron py-2 text-[12px] font-semibold text-white" data-testid="mobile-bar-book"><CalendarCheck className="h-5 w-5" aria-hidden />Book Now</Link>
    </div>
  );
}
